export default __webpack_public_path__ + "static/media/laptop.1f8756b4.svg";